import {useContainerBreakpoint} from "@project/layouts";
import {routes} from "@project/router";
import {Navigate, createFileRoute, useParams} from "@tanstack/react-router";
import {useRef} from "react";

export const Route = createFileRoute("/_app/user-management/users/$userId/")({
  component: IndexRouteComponent,
});

function IndexRouteComponent() {
  const {userId} = useParams({strict: false}) as {userId: string};
  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useContainerBreakpoint(ref);

  if (isDesktop) {
    return (
      <Navigate replace params={{userId}} to={routes.usermanagement.users.user().permissions()} />
    );
  }

  return <div ref={ref} className="h-full w-full" />;
}
